/* Número na tela em português (PROMPT 156): vírgula decimal, ponto de milhar,
 * dinheiro no padrão R$. Antes cada tela usava `toFixed`, que sempre põe PONTO
 * decimal ("0.00 usados", "R$ 1299.00").
 *
 * Valor nulo, vazio ou que não é número vira "-", o marcador de valor vazio da
 * plataforma (decisão do fundador de 22/10). Só para EXIBIÇÃO: valor de campo de
 * formulário e valor enviado ao servidor continuam como estão. */

export const VAZIO = '-';

const numero = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : null;
};

/** 1234.5 -> "1.234,5". `casas` é o máximo; `minimo` (padrão = casas) fixa os zeros à direita. */
export function formatarNumero(valor, { casas = 0, minimo = casas } = {}) {
  const n = numero(valor);
  if (n === null) return VAZIO;
  return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: minimo, maximumFractionDigits: casas }).format(n);
}

/** 1234.5 -> "R$ 1.234,50" (o Intl separa "R$" do número com espaço não separável). */
export function formatarMoeda(valor, { casas = 2 } = {}) {
  const n = numero(valor);
  if (n === null) return VAZIO;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency', currency: 'BRL', minimumFractionDigits: casas, maximumFractionDigits: casas,
  }).format(n);
}

/** LOTE 204 (C1): os créditos são da régua em MILHAR, sempre inteiros, com o ponto de milhar do pt-BR:
 *  59700 -> "59.700 créditos" (1 -> "1 crédito"); `unidade: false` devolve só o número. As opções antigas de casas
 *  decimais (`casas`, `fixo`) não valem mais: crédito não tem fração. */
export function formatarCreditos(valor, { unidade = true } = {}) {
  const n = numero(valor);
  if (n === null) return VAZIO;
  const inteiro = Math.round(n);
  const texto = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(inteiro);
  if (!unidade) return texto;
  return `${texto} ${Math.abs(inteiro) === 1 ? 'crédito' : 'créditos'}`;
}
